<template>
  <div class="info">
    <h2>{{keyword}} in {{category}}:第{{page}}页/共{{totalPage}}页</h2>
  </div>
</template>

<script>
export default {
  name: "Info",
  props: {
    keyword: String,
    category: String,
    page: Number,
    totalPage: Number
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info {
  padding: 50px;
}
h3 {
  margin: 40px 0 0;
}
h2 {
  text-align: center;
  font-family: "kaiti";
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
